import { FileInput, FileInputProps } from 'app/components/ui/FileInput'
import { FormFeedback } from 'app/components/ui/FormFeedback'
import { Label } from 'app/components/ui/Label'
import { Text } from 'app/components/ui/Text'
import { theme } from 'app/styles/themeEstra'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import styled, { css } from 'styled-components'

export type SmartFileInputProps = {
  name: string
  label?: string
  labelColor?: string
  errorLabelColor?: string
  labelRequired?: boolean
  description?: string
  descriptionColor?: string
} & FileInputProps

export const SmartFileInput = ({
  name,
  id,
  label,
  labelColor,
  errorLabelColor,
  labelRequired,
  description,
  descriptionColor,
  children,
  ...rest
}: WithChildren<SmartFileInputProps>): JSX.Element => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext()

  return (
    <div>
      {label && (
        <Label htmlFor={id ?? name} color={labelColor} disabled={rest.disabled}>
          {label} {labelRequired ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}

      <FileInput
        id={id ?? name}
        {...register(name)}
        {...rest}
        OnClearInput={() => setValue(name, null)}
      />
      {description && (
        <DescriptionText
          variant='s12'
          color={descriptionColor || theme.color.primari.grigioEstra}
          mt={0.5}
          isItalic
          disabled={rest.disabled}
        >
          {description}
        </DescriptionText>
      )}
      {errors[name] ? (
        <FormFeedback customColor={errorLabelColor} variant='error'>
          {errors[name].message}
        </FormFeedback>
      ) : null}
      {children && <InputFooter>{children}</InputFooter>}
    </div>
  )
}

type DescriptionTextProps = Pick<SmartFileInputProps, 'disabled'>

const DescriptionText = styled(Text)<DescriptionTextProps>`
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.7;
        `
      : null}
`

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`

const InputFooter = styled.div`
  margin-top: 2rem;
`
